import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { callbackUri } from "../auth.config";
import { Browser } from "@capacitor/browser";
import { LoadingController } from "@ionic/angular";
import { catchError, Observable, of, switchMap, take } from "rxjs";
import moment, { MomentSetObject } from 'moment';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from "jspdf-autotable";
import { font } from '../util/pdf-fontok/Bitter-Regular-normal'
import { fontB } from '../util/pdf-fontok/Bitter-Bold-normal'
import { font2 } from '../util/pdf-fontok/Ionicons-normal'
import { KeycloakService } from "keycloak-angular";
import { DataService } from '../data.service';
import { AuthService } from '../auth.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { etkezesNapiAr, osszesMenu } from '../util/etkezes-ar';
import { honapCimke, RiportCella, RiportOszlop, RiportSor, RiportTabla } from '../riport-pdf';
import { EtlapSor, etlapNaponta, menuEtele } from '../components/etkezes-etlap/etlap-kozos';

@Component({
  selector: 'app-etkezes',
  templateUrl: './etkezes.component.html',
  styleUrls: ['./etkezes.component.scss'],
})
export class EtkezesComponent implements OnInit, OnDestroy {
  // Üres tömbbel indul, nem deklarálatlanul: dolgozói belépésnél a képernyő
  // OSZTÁLYVÁLASZTÁS ELŐTT is kirajzolódik (a névsort csak a választás tölti be),
  // és a havi számolás ilyenkor egy nem létező listán futott volna végig.
  ports: any[] = []
  intezmenyek = []
  
  uuid
  port
  today = new Date();
  selectedMonth: number = this.today.getMonth() + 1; // Example: July
  selectedYear: number = this.today.getFullYear(); // Example: Year 2023
  selectedMonthS: any = (this.today.getMonth() + 1).toString(); // Example: July
  selectedYearS: number = this.today.getFullYear(); // Example: Year 2023
  selectedDay: number = this.today.getDate();
  daysInMonth = []
  portsDef: any[] = []
  holidays
  user$ //= this.auth.isAuthenticated$.pipe(switchMap(() => this.auth.user$));
  userMetadata;
  sajatIntezmeny
  sajatnev = ""
  hanyados = 0;
  aloldal = "2"
  /** A „Napi hiányzók (ebéd)" ablak (#1070) – csak dolgozói nézetben. */
  napiHianyzokNyitva = false
  weekNum = -1
  statuszok = [
    ["alert", "danger", "Nincs adat"],
    ["checkmark-circle-outline", "success", "Dolgozik"],
    ["bed", "tertiary", "Fizetett szabadság"],
    ["medkit", "warning", "Betegszabadság / táppénz"],
    ["car", "secondary", "Iskolai kiküldetés"],
    ["ban", "dark", "Fizetés nélküli szabadság"],
    ["leaf", "success", "Nincs tanítási órám"],
    ["globe", "secondary", "Digitális távoktatás"],
  ];
  torlesreKuld = [];
  osszegzes = []
  /*  Napi bontás MENÜNKÉNT.
   *
   *  A napi összesítő eddig egyetlen számot mutatott: hány adag kell aznap. A
   *  konyhának viszont az kell, MELYIK menüből mennyi - a beszállítónak menünként
   *  kell leadni a rendelést, egy összesített darabszámból az nem jön ki.
   *
   *  Csak azok a menük kerülnek a listába, amelyeket az adott hónapban ténylegesen
   *  választottak - üres sorokkal nem terheljük a táblázatot.
   */
  menuOsszegzes: { kulcs: string; nev: string; napok: number[] }[] = []
  loginMode
  osztaly
  // Intézményi kapcsoló (Admin → Étkezés): 'havi' = a hónapra egy menü (a beszállító
  // oszlopban választva), 'napi' = naponta másik menü kérhető. A napi módban a napi
  // cellában a MENÜ SORSZÁMA látszik a pipa helyett.
  napiMenu = false;
  /*  AZ „ELŐTÖLTÉS" GOMB intézményenként kapcsolható (Admin → Étkezés). Ahol eseti az
   *  étkezés, ott egy kattintással írna felül egy egész hónapot – ezért nem mindenhol
   *  való. Alapértéke a bekapcsolt állapot, hogy a meglévő telepítéseknél semmi ne
   *  változzon; a beállítás betöltéséig is ez az érték él. */
  elotoltesEngedve = true;
  // Mobil nézet: a hónap napjai listában, modál nélkül – kis kijelzőn ez az alapértelmezett.
  mobilUserKey: any = null;

  /*  A névsort OSZTÁLYONKÉNT kérjük le.
   *
   *  Több száz tanulónál az egész iskola egyszerre másodpercekig tartó lekérdezés (a
   *  szerver minden diákra a hónap minden napját összeállítja), és a képernyő addig
   *  üresen áll. Ezért dolgozói nézetben előbb osztályt kell választani; az „Összes
   *  osztály" továbbra is elérhető, de tudatos választás. A szülő a saját gyerekeit
   *  látja, ott nincs mit szűrni.
   */
  valasztottOsztaly: string | null = null;
  /*  „Aki nem kért, ne látszódjon."
   *
   *  A hónap közepén a lista nagyobbik fele jellemzően olyan, aki egyetlen napot sem
   *  rendelt – köztük kell megkeresni azt a hármat, akinél változott valami. A szűrő
   *  csak a MEGJELENÍTÉST szűkíti: a kijelölt sorok adata változatlanul megmarad, a
   *  mentés is mindenkire vonatkozik, akinél módosítás történt. */
  csakKerok = false;
  osztalyVarakozik = false;

  isSelecting = false;
  selectedCells = new Set<string>();
  startCell: string | null = null;
  protected readonly parseFloat = parseFloat;

  // A sablon is hívja (lista-nézet étkező-választója), ezért publikus.
  getEtkezesUserKey(user: any): string | number | null {
    return user?.oktazon ?? user?.adid ?? user?.id ?? user?.user_id ?? null;
  }

  constructor(private http: HttpClient, private changeref: ChangeDetectorRef, private data: DataService,public auth: AuthService,
          public oauth: OAuthService,
    private loadingCtrl: LoadingController, private ref: ChangeDetectorRef) {

  }

  private filterVisibleOsztalyok(osztalyok: any[]): any[] {
    return (osztalyok || []).filter((o: any) => {
      return this.normalizeOsztalyNev(o?.osztaly || o?.nev || o?.name) !== '0z';
    });
  }

  private normalizeOsztalyNev(value: any): string {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, '').replace(/\./g, '');
  }

  private getSelectedOsztaly(e: any): { id: string; nev: string } {
    const selected = Array.isArray(e) ? e[0] : e;
    const selectedId = String(selected?.id ?? selected ?? '').trim();
    const osztaly = (this.osztaly || []).find((o: any) => String(o?.id ?? '').trim() === selectedId) || selected;

    return {
      id: String(osztaly?.id ?? selectedId ?? '').trim(),
      nev: this.normalizeOsztalyNev(osztaly?.osztaly || osztaly?.nev || osztaly?.name),
    };
  }

  private matchesOsztaly(user: any, selected: { id: string; nev: string }): boolean {
    const userOsztalyId = String(user?.osztaly_id ?? user?.osztalyid ?? user?.aktualis_osztaly_id ?? '').trim();
    const userOsztalyNev = this.normalizeOsztalyNev(user?.osztaly || user?.aktualis_osztaly || user?.osztaly_nev);

    return (!!selected.id && userOsztalyId === selected.id) || (!!selected.nev && userOsztalyNev === selected.nev);
  }

  private sortEtkezesRows(rows: any[]): any[] {
    return [...(rows || [])].sort((a, b) => {
      const aName = `${a?.viselt_vez || ''} ${a?.viselt_ker || ''}`.trim();
      const bName = `${b?.viselt_vez || ''} ${b?.viselt_ker || ''}`.trim();
      return aName.localeCompare(bName, 'hu');
    });
  }

  async ngOnInit() {
    await this.oauth.loadUserProfile();
      this.user$ = this.data.belepoKilet(this.oauth.getIdentityClaims());
    
    this.loginMode = await this.data.getFromStorage("loginmode")

    this.userMetadata = (await this.data.getFromStorage("userMetadata"))
    //this.userMetadata.department = "rendszergazda"
    this.uuid = this.user$.username
    //this.getMeta();
    this.sajatnev = this.userMetadata.viselt_vez + " " + this.userMetadata.viselt_ker//this.user$.attributes.name
    //console.log(this.userMetadata.intezmenyadatok)
    //console.log(JSON.parse(this.userMetadata.intezmenyadatok))
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.intezmenyek = this.userMetadata.intezmenyadatok.sort((a, b) => (a.intezmenyName > b.intezmenyName) ? 1 : ((b.intezmenyName > a.intezmenyName) ? -1 : 0))

    let akttev = JSON.parse(await this.data.getFromStorage("tanev")).aktualistanev
    let tanev = JSON.parse(await this.data.getFromStorage("tanevadatok")).filter(d => d.id == akttev)[0];
    this.osztaly = this.filterVisibleOsztalyok(
      await this.data.getOsztaly(moment(tanev.tankezd).format("YYYY"), this.sajatIntezmeny.intezmenyId).toPromise()
    );

    this.hanyados = this.sajatIntezmeny.intezmenyEtkezes
    // Kis kijelzőn a lista-nézet nyílik (a táblázat 31 oszlopa ott használhatatlan).
    this.aloldal = window.innerWidth < 900 ? "1" : "2";
    this.betoltBeallitas();
    //console.log(this.port)
    this.weekNum = this.getWeekOfMonth(this.today);
    if (this.loginMode == "dolgozo") {
      // Nincs automatikus teljes-iskola lekérés: a felhasználó választ osztályt.
      this.osztalyVarakozik = true;
      this.getData(this.selectedYear, this.selectedMonth);
    } else {
      this.data.showLoading('Adatok betöltése...').then(() => {
        this.getMunkatarsakNew()
      });
    }
  }

  ngOnDestroy() {
    //document.removeEventListener('mouseup', this.mouseUpEvent.bind(this));

  }

  setWeekNum(id) {
    this.weekNum = id;
    //let dim = this.daysInMonth
    //this.daysInMonth.filter(item => item.week === id-1);
    //setTimeout(() => this.daysInMonth = dim, 0);
    this.daysInMonth = [...this.daysInMonth]
    this.changeref.detectChanges()
  }
  getWeekOfMonth(date) {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstDayOfWeek = firstDayOfMonth.getDay(); // getDay() returns 0 for Sunday, 1 for Monday, etc.
    const dayOfMonth = date.getDate();

    // Calculate full weeks to passed days in the month plus the shift of the start day of the week
    return Math.ceil((dayOfMonth + firstDayOfWeek) / 7);
  }
  weekCount(mode = 0) {

    // month_number is in the range 1..12

    var firstOfMonth = new Date(this.selectedYear, this.selectedMonth - 1, 1);
    var lastOfMonth = new Date(this.selectedYear, this.selectedMonth, 0);

    var used = firstOfMonth.getDay() + 6 + lastOfMonth.getDate();



    return new Array(Math.floor(used / 7));

  }

  /*  A TÁBLÁZATBAN MEGJELENŐ SOROK. A `ports` marad a teljes, betöltött névsor –
   *  a mentés, az összegzés és a napi műveletek azzal dolgoznak –, itt csak azt
   *  döntjük el, mi látszik belőle. */
  get lathatoPortok(): any[] {
    if (!this.csakKerok) return this.ports || [];
    return (this.ports || []).filter(u => this.kertValamit(u));
  }

  /** Kért-e a hónapban legalább egy napot? */
  kertValamit(user): boolean {
    return (user?.adatok || []).some(d => d?.value == 1);
  }

  /** Hány sort rejt el éppen a szűrő – enélkül úgy tűnne, hiányzik valaki a névsorból. */
  get elrejtettDb(): number {
    return (this.ports?.length || 0) - this.lathatoPortok.length;
  }

  /*  AZ EGÉSZ ISKOLA egyetlen gombbal. Eddig ez csak úgy volt elérhető, hogy a
   *  választót KIÜRÍTETTE a felhasználó – amit a mellette álló magyarázó szöveg
   *  mondott el, tehát tudni kellett hozzá. Egy gomb ugyanaz, csak látszik is. */
  async osszesTanulo() {
    this.valasztottOsztaly = null;
    this.osztalyVarakozik = false;
    this.portsDef = [];
    this.ports = [];
    await this.data.showLoading("Egy pillanat...");
    this.getMunkatarsakNew();
  }

  async EtkezesSzuro(e){
    const selected = this.getSelectedOsztaly(e);
    // A választó ürítése („Összes osztály") tudatos döntés: ilyenkor jöhet az egész
    // iskola, de csak ekkor.
    this.valasztottOsztaly = selected.id || null;
    this.osztalyVarakozik = false;
    this.portsDef = [];
    this.ports = [];
    await this.data.showLoading("Egy pillanat...")
    this.getMunkatarsakNew()
  }

  searchM() {
    this.selectedYear = this.selectedYearS
    this.selectedMonth = this.selectedMonthS
    this.daysInMonth = [];
    this.portsDef = [];
    this.ports = [];
    this.weekNum = this.getWeekOfMonth(new Date(this.selectedYear, this.selectedMonth, 1));
    if (this.loginMode == "dolgozo" && this.osztalyVarakozik) {
      this.getData(this.selectedYear, this.selectedMonth);
      return;
    }
    this.data.showLoading('Adatok betöltése...').then(() => {
      this.getMunkatarsakNew()
    });
  }

  resetM() {
    this.selectedMonth = this.today.getMonth() + 1; // Example: July
    this.selectedYear = this.today.getFullYear(); // Example: Year 2023
    this.selectedMonthS = this.today.getMonth() + 1; // Example: July
    this.selectedYearS = this.today.getFullYear(); // Example: Year 2023
    this.getData(this.selectedYear, this.selectedMonth)
  }


  async selectChanged(e) {
    this.data.showLoading('Adatok lekérése...');
    //console.log(e)
    this.ports = this.portsDef.filter(d => d.om == e[0].om).sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0));
    //this.sajatIntezmeny = e[0]
    this.sajatIntezmeny = await this.data.getFromStorage("sajatIntezmeny")
    //console.log(this.sajatIntezmeny)
    this.getData(this.selectedYear, this.selectedMonth);

  }

  

  getDifference(array1, array2, key) {
    return array1.filter(obj1 => !array2.some(obj2 => obj1[key] === obj2[key]));
  }

  async saveData() {
    this.data.showLoading("Adatok mentése...");
    let kuld = [];
    kuld["replace"] = [];
    kuld["delete"] = [];
    const days = new Date(this.selectedYear, this.selectedMonth, 0).getDate();

    this.torlesreKuld.forEach(d => {
      const currentDate = new Date(this.selectedYear, this.selectedMonth - 1, d.index + 1);
      kuld["delete"].push({
        user: d.user,
        date: moment(currentDate).format("YYYY-MM-DD")
      })
    })
    for await (let d of this.ports) {

      // A ciklus a HÓNAP napjain megy végig, nem a tömb hosszán: a `new Date(év, hó-1, i+1)`
      // a tömb végén túl már a KÖVETKEZŐ hónap napjait adná, és oda írnánk be az ebédet.
      const hatar = Math.min(days, d.adatok?.length || 0);
      for (let i = 0; i < hatar; i++) {
        if (d.adatok[i]?.value == 1 && d.adatok[i]?.tranzakcio != 1) {

          const currentDate = new Date(this.selectedYear, this.selectedMonth - 1, i + 1);

          kuld["replace"].push({
            user: this.getEtkezesUserKey(d),
            date: moment(currentDate).format("YYYY-MM-DD"),
            intezmeny: this.sajatIntezmeny.intezmenyId,
            menu: d.adatok[i].menu || null
          })
          continue;
        }

      }
    }

    console.log(kuld)
    this.http.post("/api/etkezes/save", [kuld["replace"], kuld["delete"]])
      .subscribe({
        next: (d: any) => {

        this.data.hideLoading()
        console.log(d)

        if (d.status == "OK" && d.zarolt?.length)
          // A kiszolgáló a program miatt zárolt napokat kiszűrte – ezt ki kell mondani.
          this.data.sendToast(`Mentve – de ${d.zarolt.length} nap iskolai program miatt zárolt, `
            + "arra nem rendeltünk ebédet.", "warning")
        else if (d.status == "OK" && d.kimaradt?.length)
          //  A határidőn túli vagy már számlázott napot a kiszolgáló nem módosította.
          this.data.sendToast(`Mentve – de ${d.kimaradt.length} nap nem módosult: a határidő lejárt `
            + "vagy a nap már számlázva van.", "warning")
        else if (d.status == "OK")
          this.data.sendToast("Sikeres mentés", "success")

        else
          this.data.sendToast(d?.error || "Hiba történt a feldolgozás során!", "error")
        },
        error: (err) => {
          this.data.hideLoading()
          this.data.sendToast(err?.error?.error || "Hiba történt a mentés során!", "error")
        }
      });
  }

  getMunkatarsakNew() {
    let body = []
    if (this.userMetadata.gyermekek) body = this.userMetadata.gyermekek
    const szuro = this.valasztottOsztaly
      ? '?osztaly=' + encodeURIComponent(this.valasztottOsztaly) : '';
    this.http
      .post(
        '/api/etkezes/tanulo/' + this.selectedYear + '/' + this.selectedMonth + '/' + this.sajatIntezmeny.intezmenyId + szuro,
        body
      )
      .subscribe({
        next: (response: any) => {
          //console.log(response);
          let penzf = new Intl.NumberFormat('hu-HU', {
            style: 'currency',
            currency: 'HUF',
            maximumFractionDigits: 0,
          });

          response.forEach((element) => {
            element.user_id = element.id;
            element.name = element.viselt_vez + " " + element.viselt_ker;
            element.adatok = JSON.parse("[" + element.adatok + "]");
            element.osszeg = 0;
            element.osszegC = 0;
            element.beszallitok = element.beszallitok || [];
            element.idoszakok = element.idoszakok || [];
            try { element.etkezes_hely_adatok = JSON.parse(element.etkezes_hely_adatok); } catch (e) { }
            // Az étkezés tényét az IDŐSZAK mondja meg, nem a régi tanulo.etkezes kapcsoló:
            // amíg nincs rögzített belépés, a sor szürke és nem szerkeszthető.
            /*  AKTÍV = VAN ÉLŐ BELÉPÉSE.
             *
             *  Eddig bármelyik időszak (a rég lezárt is) aktívvá tette a sort, mert a
             *  keresés visszaesett az UTOLSÓ időszakra. Így a kiléptetett diák sora is
             *  szerkeszthetőnek látszott, holott már nem étkezik. Aktív az, akinek
             *  NYITOTT időszaka van – vagy akinek egy lezárt időszaka még a MEGJELENÍTETT
             *  hónapba nyúlik, mert a korábbi hónapok adatát látni kell. */
            const nyitott = element.idoszakok.find(p => !this.idoszakLezart(p)) || null;
            const aktivIdoszak = nyitott || element.idoszakok[element.idoszakok.length - 1];
            element.nyitottIdoszak = nyitott;
            element.aktiv = !!nyitott || this.idoszakErintiHonapot(element);
            // Egy beszállítónál nincs mit választani: az az alapértelmezés mindenkinél
            // (enélkül üres a menülista, és a napi menüválasztó meg sem jelenik).
            element.selectedHely = aktivIdoszak?.hely || element.aktualis_hely || this.egyetlenHely(element);
            element.menuk = this.helyMenui(element, element.selectedHely);
            element.selectedMenu = aktivIdoszak?.menu || element.menuk[0]?.id || null;

            // A MEGJELENÍTETT HÓNAP menüje az irányadó a választóban. Eddig az időszak
            // alapmenüje került bele, ezért a havi menü átállítása után a képernyő
            // visszaugrott „alapra", pedig a hónap napjai már a másik menün álltak.
            // Ha a hónap kért napjai EGYETLEN menüt hordoznak, azt mutatjuk; ha többfélét
            // (napi módban ez normális), marad az időszak alapmenüje.
            this.honapMenujetMutasd(element);

            const days = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
            if (element.adatok.length !== days) {
              // Nem némán nyeljük le: ha ez előfordul, a naptár elcsúszik és az összeg
              // hamis. A tömböt a hónap hosszára vágjuk, hogy a pénz ne csússzon el.
              console.warn(`[etkezes] ${element.name}: ${element.adatok.length} napi bejegyzés `
                + `érkezett ${days} napos hónapra – a fölösleg eldobva.`);
              element.adatok.length = days;
            }
            for (let i = 0; i < days; i++) {
              const currentDate = new Date(this.selectedYear, this.selectedMonth - 1, i + 1);
              let isWeekend = currentDate.getDay() === 0 || currentDate.getDay() === 6;

              if (element.adatok[i]) {
                // Étkezési időszakon kívüli (még nem kért) nap kiszürkül (-2)
                if (element.adatok[i].value != 1 && !this.napAktivIdoszakban(element, currentDate)) {
                  element.adatok[i].value = -2;
                }
                if (isWeekend) {
                  element.adatok[i].value = -1;
                }
                /*  ISKOLAI PROGRAM MIATT ZÁROLT NAP (-3): a naptár programja lemondta az
                 *  ebédet, és újra nem kérhető. Az ok a cellán látszik. A szünnap (-1)
                 *  marad szünnap – ott amúgy sincs mit kérni. */
                const zarOk = element.program_zarolas?.[i];
                if (zarOk && element.adatok[i].value != -1) {
                  element.adatok[i].value = -3;
                  element.adatok[i].zar_ok = zarOk;
                }
                // Kért napra, ha nincs még menü, az alapmenüt rendeljük
                if (element.adatok[i].value == 1 && (!element.adatok[i].menu || element.adatok[i].menu == "")) {
                  element.adatok[i].menu = element.selectedMenu;
                }
              }
            }
            this.recalcOsszeg(element);
          });

          this.ports = response.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
          // A lista-nézet alapból az első étkezőt mutatja (szülőnél az első gyereket).
          if (this.ports.length && !this.ports.some(p => this.getEtkezesUserKey(p) == this.mobilUserKey)) {
            this.mobilUserKey = this.getEtkezesUserKey(this.ports[0]);
          }
          this.portsDef = this.ports //= response.sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0));
          //this.portsDef = response.filter(d => d.attributes?.title != "tanuló").sort((a, b) => (a.attributes.name > b.attributes.name) ? 1 : ((b.attributes.name > a.attributes.name) ? -1 : 0));
          //this.ports = response.filter(d => d.attributes?.title != "tanuló" && d.attributes?.company == this.sajatIntezmeny.id).sort((a, b) => (a.attributes.name > b.attributes.name) ? 1 : ((b.attributes.name > a.attributes.name) ? -1 : 0));
          this.getData(this.selectedYear, this.selectedMonth)
          //console.log(this.ports)
        },
        error: (error) => {
          // A töltésjelzőt EL KELL tüntetni. Enélkül a hibás lekérés örökre „Adatok
          // betöltése…"-n hagyta a képernyőt, és úgy nézett ki, mintha a névsor
          // egyszerűen nem töltene be – pedig a szerver hibát adott.
          console.error('Error fetching data:', error);
          try { this.data.hideLoading(); } catch (e) { }
          this.data.sendToast('A névsort nem sikerült lekérni. '
            + (error?.status === 0 ? 'Megszakadt a kapcsolat – próbáld újra.' : 'Válassz osztályt, vagy próbáld újra.'),
            'error');
        },
      });
  }

  // Az intézményi étkezés-beállítás (napi/havi menüválasztás). Külön hívás, mert a
  // sajatIntezmeny a bejelentkezéskor cache-elődik, az admin átállítása után viszont
  // azonnal érvényesnek kell lennie.
  private betoltBeallitas() {
    this.http.get<any>("/api/etkezes/beallitas/" + this.sajatIntezmeny.intezmenyId).subscribe({
      next: (r) => {
        this.napiMenu = r?.menu_valasztas === "napi";
        this.elotoltesEngedve = r?.elotoltes !== false;
        this.ref.detectChanges();
      },
      error: () => { this.napiMenu = false; },
    });
  }

  napKer(datum) {
    return moment(datum).utcOffset(0, false) //new Date(datum)
  }

  napOra(d1, d2) {
    let now = moment(d2); //todays date
    let end = moment(d1); // another date
    let duration = moment.duration(now.diff(end));
    let h = duration.asHours();
    return h
  }

  isWeekend(d) {
    const date = new Date(this.selectedYear, this.selectedMonth - 1, d);
    return date.getDay() === 0 || date.getDay() === 6;
  }

  isHoliday(d) {
    const currentDate = new Date(this.selectedYear, this.selectedMonth - 1, d).setHours(0, 0, 0, 0);
    for (const it of this.holidays || []) {
      if (new Date(it.date).setHours(0, 0, 0, 0) === currentDate) {
        return true;
      }
    }
    return false;
  }

  getHolidays(returner = false): Observable<any> {
    //console.log('Access Token:', token);
    if (returner)
      return this.http
        .get(
          // MINDEN nem-tanítási nap kell (központi ünnep + iskolai és intézményi szünet),
          // nem csak a type=0-s munkaszüneti napok – különben a szünet napján nem szürkül
          // ki a cella, és a „Összes" gomb is kiírna rá ebédet.
          '/api/nyilvantartas/holidayall/' + this.sajatIntezmeny.intezmenyId,
          {
            //headers: headers,
          }
        )
    else {
      const headers = new HttpHeaders().set(
        'Authorization',
        `Bearer `
      );
      this.http
        .get(
          // MINDEN nem-tanítási nap kell (központi ünnep + iskolai és intézményi szünet),
          // nem csak a type=0-s munkaszüneti napok – különben a szünet napján nem szürkül
          // ki a cella, és a „Összes" gomb is kiírna rá ebédet.
          '/api/nyilvantartas/holidayall/' + this.sajatIntezmeny.intezmenyId,
          {
            //headers: headers,
          }
        )
        .subscribe({
          next: (response: any) => {
            // A -2 (áthelyezett munkanap) NEM szünet: azon a napon van tanítás és ebéd.
            this.holidays = (response || []).filter((h: any) => Number(h.type) !== -2);
          },
          error: (error) => {
            console.error('Error fetching data:', error);

          },
        });
      return null;
    }


  }

  async populateDaysInMonth(response) {

    const days = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
    for (let i = 0; i < days; i++) {
      const date = new Date(this.selectedYear, this.selectedMonth - 1, i + 1); // Remember, months are 0-indexed
      const dayNumber = date.getDay();
      const dayName = date.toLocaleString('default', { weekday: 'long' });
      const isWeekend = dayNumber === 0 || dayNumber === 6;
      /*this.daysInMonth.push({
        dayNumber: i,
        dayName: dayName,
        isWeekend: isWeekend,
        nyilvantartas: null,
      });*/
      let isHoliday = false;
      for await (let element of response) {
        try {
          isHoliday = this.isHoliday(i + 1);
        } catch (e) {
        }

        if (new Date(element.start).getDate() == i + 1) {
          this.daysInMonth[i] = {
            dayNumber: i + 1,
            dayDate: date,
            dayName: dayName,
            isWeekend: isWeekend,
            nyilvantartas: element,
            isHoliday: isHoliday
          };
          break;
        }
      }
      try {
        this.data.hideLoading()
      } catch (e) {
      }
      if (!this.daysInMonth[i]) {
        this.daysInMonth[i] = {
          dayNumber: i + 1,
          dayName: dayName,
          dayDate: date,
          isWeekend: isWeekend,
          nyilvantartas: null,
          isHoliday: isHoliday
        };
      }
    }
    //console.log(this.daysInMonth)
  }
async saveDataElotolt(){
  /*  A gomb rejtve van, ha az intézmény kikapcsolta – de a rejtés önmagában nem
   *  védelem: egy nyitva hagyott, régi oldalról a hívás így is elindulhatna. */
  if (!this.elotoltesEngedve) {
    this.data.sendToast("Az előtöltés ennél az intézménynél ki van kapcsolva.", "error");
    return;
  }
  if(confirm("A művelet nem vonható vissza és felülírja a hónapot!")){
    await this.data.showLoading("Előtöltés... (Ez pár percig eltarthat és az oldal lefagyhat)")
    let i = 0
    setTimeout(() => {
      try {
      for(let s of this.ports){
    if(s.aktiv) this.tomegesKer(s,-1,1)
      i++;
    if(i==this.ports.length){ this.data.sendToast("Sikeres előtöltés!", "success")}
  };
      } finally { this.data.hideLoading(); }
    }, 1000);
  
  }
}
  tomegesKer(user, mit, mire) {
    this.daysInMonth.forEach(day => {
      if (!day.isWeekend && !day.isHoliday) this.changeKer(user, day.dayNumber - 1, mire, 1)
    })
    /*  Az „Összes" (és az Előtöltés) HAVI módban az aktuálisan kiválasztott menüre tölti
     *  ki a hónapot: a már kért, de még módosítható napok menüjét is átállítja, különben
     *  a korábban választott menü maradna rajtuk.
     *
     *  NAPI módban viszont NEM nyúlunk a meglévő napokhoz: ott a nap cellája dönt, és
     *  napról napra más menü lehet. Az „Összes nap" ilyenkor csak a HIÁNYZÓ napokat
     *  rendeli meg (azokat a `changeKer` az alapmenüvel veszi fel) – a már beállított
     *  napok választását letörölni pont azt veszítené el, amiért a napi mód van. */
    if (mire == 1 && !this.napiMenu) this.alkalmazMenuNapokra(user, user.selectedMenu);
  }

  // A megadott menüt ráteszi a hónap még szerkeszthető, megrendelt napjaira.
  private alkalmazMenuNapokra(user, menuId) {
    if (!menuId) return;
    user.adatok.forEach((d, i) => {
      if (d.value == 1 && d.tranzakcio == 0 && this.napModosithato(i)) d.menu = menuId;
    });
    this.recalcOsszeg(user);
  }

  changeKer(user, mit, mire, gep = 0) {
    if (!this.napModosithato(mit)) {
      if (gep == 0) this.data.sendToast("Ez a nap már nem módosítható – a határidő "
        + this.napHataridoSzoveg(mit) + " volt.", "error")
      return
    }
    const targetUserKey = this.getEtkezesUserKey(user);

    this.portsDef.forEach(d => {
      // -1 (hétvége/ünnep), -2 (étkezési időszakon kívül) és -3 (iskolai program) nem módosítható
      if (this.getEtkezesUserKey(d) == targetUserKey && d.adatok[mit].value > -1 && d.adatok[mit].value != mire) {

        if (d.adatok[mit].value == 1) this.torlesreKuld.push({ user: targetUserKey, index: mit });
        if (d.adatok[mit].value == 0) {
          const deleteIndex = this.torlesreKuld.findIndex(item => item.user == targetUserKey && item.index == mit);
          if (deleteIndex !== -1) {
            this.torlesreKuld.splice(deleteIndex, 1);
          }
        }
      }
    });
    this.ports.forEach(d => {
      if (this.getEtkezesUserKey(d) == targetUserKey && d.adatok[mit].value > -1 && d.adatok[mit].value != mire) {
        d.adatok[mit].value = mire
        // Bekapcsoláskor a diák aktuális alapmenüjét rendeljük a naphoz
        if (mire == 1) d.adatok[mit].menu = d.selectedMenu || null;
        this.recalcOsszeg(d);
      }
      this.ref.detectChanges()
    })

  }

  // ----- Étkezési időszakok (be/kilépés) + menü -----

  private etkezesPenzFormatter = new Intl.NumberFormat('hu-HU', {
    style: 'currency', currency: 'HUF', maximumFractionDigits: 0,
  });

  // Lezárt-e az időszak. A kilépés dátuma lehet üres, NULL vagy a MySQL '0000-00-00' –
  // mindhárom azt jelenti, hogy a belépés még él.
  private idoszakLezart(p): boolean {
    const v = String(p?.vege || '').slice(0, 10);
    return !!v && v !== '0000-00-00';
  }

  // Belenyúlik-e valamelyik időszak a megjelenített hónapba. A kiléptetett diák
  // korábbi hónapjai így olvashatók maradnak, a mostani rendelése viszont nem nyílik újra.
  private idoszakErintiHonapot(user): boolean {
    const elso = moment([this.selectedYear, this.selectedMonth - 1, 1]);
    const utolso = elso.clone().endOf('month');
    return (user?.idoszakok || []).some(p => {
      const kezdetOk = !p.kezdet || moment(p.kezdet).isSameOrBefore(utolso, 'day');
      const vegeOk = !this.idoszakLezart(p) || moment(p.vege).isAfter(elso, 'day');
      return kezdetOk && vegeOk;
    });
  }

  // Aktív-e a diák étkezése az adott napon. Étkezési időszak (belépés) nélkül
  // nincs étkezés – a régi tanulo.etkezes kapcsoló már nem játszik.
  napAktivIdoszakban(user, date): boolean {
    const idoszakok = user?.idoszakok || [];
    if (!idoszakok.length) return false;
    const d = moment(date).format("YYYY-MM-DD");
    return idoszakok.some(p => {
      const kezdetOk = !p.kezdet || moment(p.kezdet).format("YYYY-MM-DD") <= d;
      // vege = első nap, amikor már nem étkezik (exkluzív)
      const vegeOk = !this.idoszakLezart(p) || d < moment(p.vege).format("YYYY-MM-DD");
      return kezdetOk && vegeOk;
    });
  }

  /**
   *  A hónapban ténylegesen használt menü beállítása a választóra.
   *
   *  A választó azt a menüt mutassa, amit a hónapra kértek – nem az időszak
   *  alapmenüjét. A menü hordozza a beszállítót is, ezért a beszállító-választó és a
   *  menülista is követi: enélkül a menü nem is szerepelne az opciók között, és a
   *  select üresen/az elsőn állna.
   */
  private honapMenujetMutasd(user) {
    const menuk = new Set<string>();
    for (const d of user?.adatok || []) {
      if (String(d?.value) === '1' && d?.menu) menuk.add(String(d.menu));
    }
    if (menuk.size !== 1) return;              // nincs kért nap, vagy naponta más menü

    const menuId = [...menuk][0];
    const hely = (user?.beszallitok || []).find((b) => (b.menuk || []).some((m) => String(m.id) === menuId));
    if (!hely) return;                          // törölt menü: marad az alapértelmezés

    user.selectedHely = hely.id;
    user.menuk = this.helyMenui(user, hely.id);
    user.selectedMenu = menuId;
  }

  /*  Ha az intézménynek EGYETLEN beszállítója van, az az alapértelmezés – nem kérdés,
   *  hanem tény. Több beszállítónál nem tippelünk: ott a választás valódi döntés
   *  (más ár, más szállítás), és a felhasználónak kell megejtenie. */
  private egyetlenHely(user): string | null {
    const b = user?.beszallitok || [];
    return b.length === 1 ? b[0].id : null;
  }

  // Egy beszállító (étkezőhely) menüi. A választó ebből épül.
  helyMenui(user, helyId): any[] {
    const hely = (user?.beszallitok || []).find(b => b.id == helyId);
    return hely?.menuk || [];
  }

  helyNeve(user, helyId): string {
    const hely = (user?.beszallitok || []).find(b => b.id == helyId);
    return hely?.nev || user?.etkezes_hely_adatok?.nev || '';
  }

  // Az adott nap ára. Az árat a MENÜ hordozza (diétás igény = külön menü), a diák
  // kedvezménye ezen felül érvényesül – a képlet közös a pénzügyi kiírással.
  // A nap SAJÁT menüje az irányadó: egy korábbi beszállítónál rendelt nap
  // beszállítóváltás után is a régi áron marad.
  napiAr(user, i): number {
    const d = user?.adatok?.[i];
    if (!d || d.value != 1) return 0;
    return etkezesNapiAr(user, d);
  }

  // A hónap napjainak száma – az `adatok` tömb ennél hosszabb SOHA nem lehet.
  private get honapNapjai(): number {
    return new Date(this.selectedYear, this.selectedMonth, 0).getDate();
  }

  recalcOsszeg(user) {
    // Szigorúan a hónap napjaira összegzünk. Ha a szerver bármi okból többet küld,
    // a fölösleg nem szólhat bele a fizetendőbe – egy sokszorozó join egyszer már
    // a duplájára hizlalta a havi összeget.
    const napok = Math.min(this.honapNapjai, user?.adatok?.length || 0);
    let sum = 0;
    for (let i = 0; i < napok; i++) sum += this.napiAr(user, i);
    user.osszegC = sum;
    user.osszeg = this.etkezesPenzFormatter.format(sum);
  }

  /*  ÉTKEZÉSI NAP-E? Hétköznap, ami nem szünet. A szüneteket a kiszolgáló jelöli
   *  (a napi érték -1), ezért a megjelenített hónapra pontosan tudjuk; a hónapon
   *  kívüli napoknál a hétvége-szabály marad – a kiszolgáló úgyis a teljes naptárral
   *  ellenőriz, ez csak azt dönti el, mit engedünk elkezdeni. */
  private etkezesiNap(m: any): boolean {
    const h = m.isoWeekday();
    if (h > 5) return false;
    if (m.year() === this.selectedYear && (m.month() + 1) === this.selectedMonth) {
      const idx = m.date() - 1;
      const barki = this.ports?.[0];
      if (barki?.adatok?.[idx] && Number(barki.adatok[idx].value) === -1) return false;   // szünet
    }
    return true;
  }

  /**
   *  A NAP HATÁRIDEJE – étkezési napokban visszaszámolva.
   *
   *  Naptári napokkal számolva egy HÉTFŐI ebéd határideje „egy nappal korábban"
   *  VASÁRNAP lett volna: olyan nap, amikor az iskola zárva és a konyha nem dolgozik.
   *  A helyes válasz a PÉNTEK — ezért csak az étkezési napokat számoljuk.
   */
  private napHatarideje(mit: number): any {
    const cel = moment([this.selectedYear, this.selectedMonth - 1, mit + 1]).startOf('day');
    let m = cel.clone();
    let hatra = Math.max(0, Number(this.sajatIntezmeny?.zaras_etkezes) || 0);
    for (let i = 0; hatra > 0 && i < 30; i++) {
      m = m.subtract(1, 'day');
      if (this.etkezesiNap(m)) hatra -= 1;
    }
    return m.clone().hour(Number(this.sajatIntezmeny?.zaras_etkezes_ora) || 0).minute(0).second(0);
  }

  // Módosítható-e még az adott napi cella (határidő-szabály, admin bypass)
  napModosithato(mit): boolean {
    if (this.user$?.attributes?.jogkor?.indexOf("admin") != -1) return true;
    return moment().isSameOrBefore(this.napHatarideje(mit));
  }

  /** A határidő olvasható alakja – a hibaüzenet ettől lesz megfogható. */
  napHataridoSzoveg(mit: number): string {
    return this.napHatarideje(mit).format('YYYY. MM. DD. (dddd) HH:mm');
  }

  /* ─────────── NAPI menüválasztás (intézményi kapcsolóval) ───────────
     Napi módban a nap cellája nem pipa, hanem a MENÜ SORSZÁMA: a diák minden napra
     külön menüt kérhet. A sorszám a beszállító menülistájában elfoglalt hely (1., 2., …),
     mert a nevek hosszúak, a hónap pedig 31 oszlop. */

  // Az adott nap cellája napi menüválasztós-e (több menü + még szerkeszthető nap).
  napiCella(user, idx): boolean {
    if (!this.napiMenu || !(user?.menuk?.length > 1)) return false;
    const d = user?.adatok?.[idx];
    return !!d && d.tranzakcio == 0 && (d.value == 0 || d.value == 1);
  }

  /*  A MENÜ RÖVID JELE a napi cellához.
   *
   *  Egy hónap 31 oszlop, oda a menü teljes neve nem fér ki – de a SORSZÁM megtévesztő
   *  volt: ahol a menük neve „A" és „B", ott az 1-es és a 2-es semmit nem jelent, sőt
   *  az olvasó a menü nevének hiszi. Ezért a menü SAJÁT jelét írjuk ki:
   *
   *    • rövid név (max 3 jel: „A", „B", „I.") → maga a név,
   *    • hosszú név → a kezdőbetűje, ha az a listán egyértelmű („Normál" → N),
   *    • ha két menü ugyanazzal a betűvel kezdődik, ott marad a sorszám – ott a
   *      betű összekeverné őket, és a keverés rosszabb, mint a semmitmondó szám.
   *
   *  A teljes név mindenhol ott van a cella címében (tooltip) és a jelmagyarázatban. */
  menuCimke(user, menuId): string {
    const menuk = user?.menuk || [];
    const i = menuk.findIndex(m => m.id == menuId);
    if (i < 0) return menuId ? '•' : '';       // korábbi beszállító menüje
    const nev = String(menuk[i].nev ?? '').trim();
    if (!nev) return String(i + 1);
    if (nev.length <= 3) return nev;
    const elso = nev[0].toUpperCase();
    const azonosKezdetu = menuk.filter(m => String(m.nev ?? '').trim()[0]?.toUpperCase() === elso).length;
    return azonosKezdetu === 1 ? elso : String(i + 1);
  }

  // Kell-e jelmagyarázat a napi cellák alá. Ahol a rövid jel MAGA a menü neve
  // („A", „B"), ott az „A = A" sor csak zaj.
  kellJelmagyarazat(user): boolean {
    return (user?.menuk || []).some(m => this.menuCimke(user, m.id) !== String(m.nev ?? '').trim());
  }

  // A napi választó értéke: kért napnál a nap menüje, egyébként üres (= nem kér).
  napMenuErtek(user, idx): string {
    const d = user?.adatok?.[idx];
    if (!d || d.value != 1) return '';
    return d.menu || user.selectedMenu || '';
  }

  // Nyomtatáshoz/PDF-hez a cella szöveges tartalma (a select nem nyomtatható értelmesen).
  napiMenuSzam(user, idx): string {
    const d = user?.adatok?.[idx];
    if (!d || d.value != 1) return '';
    return this.menuCimke(user, d.menu || user.selectedMenu) || 'X';
  }

  napMenuNeve(user, menuId): string {
    const m = osszesMenu(user).find(x => x.id == menuId);
    return m ? `${m.nev} (${m.ar} Ft)` : '';
  }

  // Egy nap menüjének átállítása. Üres érték = a nap lemondása. Ha a nap még nem volt
  // megrendelve, a választás egyben meg is rendeli.
  napMenuValaszt(user, idx, menuId) {
    if (!menuId) { this.changeKer(user, idx, 0); return; }
    if (!this.napModosithato(idx)) {
      this.data.sendToast("Ez a nap már nem módosítható – a határidő "
        + this.napHataridoSzoveg(idx) + " volt.", "error");
      this.ref.detectChanges();
      return;
    }
    if (user.adatok[idx].value != 1) this.changeKer(user, idx, 1);
    if (user.adatok[idx].value != 1) return;   // hétvége / időszakon kívüli nap
    const kulcs = this.getEtkezesUserKey(user);
    this.ports.forEach(d => {
      if (this.getEtkezesUserKey(d) == kulcs) {
        d.adatok[idx].menu = menuId;
        this.recalcOsszeg(d);
      }
    });
    this.ref.detectChanges();
  }

  /* ─────────── Mobil nézet (lista, modál nélkül) ─────────── */

  get mobilUser() {
    if (!this.ports?.length) return null;
    const kulcs = this.mobilUserKey;
    return this.ports.find(p => this.getEtkezesUserKey(p) == kulcs) || this.ports[0];
  }

  // A nap állapota a lista-nézethez: mit lehet vele csinálni.
  napAllapot(user, idx): string {
    const d = user?.adatok?.[idx];
    if (!d) return 'nincs';
    if (d.value == -1) return 'hetvege';
    if (d.value == -2) return 'kivul';
    if (d.value == -3) return 'program';
    if (d.value == 1 && d.tranzakcio == 1) return 'szamlazott';
    return d.value == 1 ? 'kert' : 'nem';
  }

  // Kért-e a nap (lista-nézet pipa/chip állapotához).
  napKert(user, idx): boolean {
    return user?.adatok?.[idx]?.value == 1;
  }

  // Kapcsolható-e a nap a lista-nézetben egy koppintással (nem napi menüválasztós sor,
  // és se nem hétvége, se nem időszakon kívüli, se nem számlázott nap). A határidőt NEM
  // nézzük: azt a changeKer mondja meg, hogy a felhasználó üzenetet kapjon róla.
  napValthato(user, idx): boolean {
    if (this.napiCella(user, idx)) return false;
    const a = this.napAllapot(user, idx);
    return a == 'kert' || a == 'nem';
  }

  // Lejárt-e már a nap módosítási határideje (a listában jelezzük).
  napZart(user, idx): boolean {
    const a = this.napAllapot(user, idx);
    return (a == 'kert' || a == 'nem') && !this.napModosithato(idx);
  }

  // A nap kérése / lemondása a lista-nézetben (a sorra koppintva).
  napValt(user, idx) {
    this.changeKer(user, idx, this.napKert(user, idx) ? 0 : 1);
  }

  // Menüváltás: a még szerkeszthető, kért napokra azonnal alkalmazza (határidőn belül),
  // és elmenti a nyitott időszakra is, hogy az ezután kért napok is ezt kapják.
  setSelectedMenu(user, menuId) {
    user.selectedMenu = menuId;
    // Napi menüválasztásnál a hónap napjai egyedileg állnak – a fejlécben választott menü
    // csak az EZUTÁN kért napokra vonatkozik, a meglévőket nem írjuk felül.
    if (!this.napiMenu) this.alkalmazMenuNapokra(user, menuId);
    this.recalcOsszeg(user);
    this.ref.detectChanges();
    this.mentBeszallito(user);
  }

  // Beszállítóváltás: az új beszállító első menüjére állunk (vagy az ottani
  // azonos nevűre, ha van), és onnantól oda megy a rendelés.
  setSelectedHely(user, helyId) {
    user.selectedHely = helyId;
    user.menuk = this.helyMenui(user, helyId);
    if (!user.menuk.length) {
      this.data.sendToast("Ehhez a beszállítóhoz még nincs menü rögzítve.", "error");
      this.ref.detectChanges();
      return;
    }
    const regiNev = osszesMenu(user).find(m => m.id == user.selectedMenu)?.nev;
    const uj = user.menuk.find(m => m.nev == regiNev) || user.menuk[0];
    this.setSelectedMenu(user, uj.id);
  }

  // A választás mentése a nyitott időszakra (a szerver a még módosítható napokat is átállítja).
  private mentBeszallito(user) {
    if (!user?.selectedMenu || !user?.nyitottIdoszak) return;
    const isAdmin = this.user$?.attributes?.jogkor?.indexOf("admin") != -1;
    this.http.post("/api/etkezes/beszallito", {
      user: this.getEtkezesUserKey(user),
      intezmeny: this.sajatIntezmeny.intezmenyId,
      menu: user.selectedMenu,
      hely: user.selectedHely,
      admin: isAdmin,
    }).subscribe({
      next: () => this.data.sendToast("Menü/beszállító mentve.", "success"),
      error: (err) => this.data.sendToast(err?.error?.error || "A menüváltás mentése sikertelen.", "error"),
    });
  }

  // ---- Be/kilépés kezelés ----
  idoszakUser: any = null;
  idoszakDatum: string = moment().format("YYYY-MM-DD");

  megnyitIdoszak(user) {
    this.idoszakUser = user;
    this.idoszakDatum = moment().format("YYYY-MM-DD");
    // Belépéshez kell beszállító: ha még nincs, az első menüvel rendelkezőt kínáljuk.
    if (!user.selectedHely) {
      const elso = (user.beszallitok || []).find(b => (b.menuk || []).length);
      if (elso) {
        user.selectedHely = elso.id;
        user.menuk = elso.menuk;
        user.selectedMenu = elso.menuk[0]?.id || null;
      }
    }
  }

  // A belépés-modálban a beszállító váltása még nem ment (nincs mit menteni):
  // csak a menülistát cseréli, a rögzítés a Belépés gombbal történik.
  valasztHely(user, helyId) {
    user.selectedHely = helyId;
    user.menuk = this.helyMenui(user, helyId);
    user.selectedMenu = user.menuk[0]?.id || null;
  }

  bezarIdoszak() {
    this.idoszakUser = null;
  }

  private idoszakMuvelet(muvelet: "belepes" | "kilepes") {
    if (!this.idoszakUser) return;
    const isAdmin = this.user$?.attributes?.jogkor?.indexOf("admin") != -1;
    const body: any = {
      user: this.getEtkezesUserKey(this.idoszakUser),
      intezmeny: this.sajatIntezmeny.intezmenyId,
      muvelet,
      admin: isAdmin,
      letrehozta: this.sajatnev,
    };
    if (muvelet === "belepes") {
      body.kezdet = this.idoszakDatum;
      // A belépés nem dönt menüről: azt a nap hordozza (napi módban naponta, haviban a
      // hónap választója). Beszállítót viszont rögzítünk – abból derül ki, kihez ment a
      // rendelés abban az időszakban; egy beszállítónál ez magától az egyetlen.
      body.menu = null;
      body.hely = this.idoszakUser.selectedHely || null;
      /*  A MENŰT ITT NEM KÉRJÜK – ÉS NEM IS SZABAD SZÁMON KÉRNI.
       *
       *  A belépés azt rögzíti, hogy a diák étkezik, nem azt, hogy MIT eszik: a menüt a
       *  nap hordozza. A fenti sor ezért szándékosan null-ra állítja – az ellenőrzés
       *  viszont pont erre a null-ra futott rá, így a belépés SOHA nem ment át:
       *  „Előbb válassz beszállítót és menüt!", holott menüt nem is lehetett választani.
       *  Beszállító viszont kell (abból derül ki, kihez ment a rendelés), de ha az
       *  intézménynek egy sincs, akkor nem választani kell, hanem felvenni. */
      if (!body.hely) {
        this.data.sendToast(this.idoszakUser.beszallitok?.length
          ? "Előbb válassz beszállítót!"
          : "Az intézménynek nincs beszállítója (Admin → Étkezés), ezért a belépés nem rögzíthető.",
          "error");
        return;
      }
    } else {
      body.vege = this.idoszakDatum;
    }

    this.data.showLoading(muvelet === "belepes" ? "Belépés rögzítése..." : "Kilépés rögzítése...");
    this.http.post("/api/etkezes/idoszak", body).subscribe({
      next: (res: any) => {
        this.data.hideLoading();
        if (res.status == "OK") {
          if (muvelet === "kilepes") {
            const l = res.lemondas || { torolt: 0, modositok: [] };
            let uzenet = `Kilépés rögzítve. ${l.torolt || 0} nap lemondva.`;
            if (l.modositok?.length) uzenet += ` ${l.modositok.length} módosító számla a már kiszámlázott napokról.`;
            this.data.sendToast(uzenet, "success");
          } else {
            this.data.sendToast("Belépés rögzítve!", "success");
          }
          this.bezarIdoszak();
          this.getMunkatarsakNew();
        } else {
          this.data.sendToast(res.error || "A művelet sikertelen.", "error");
        }
      },
      error: (err) => {
        this.data.hideLoading();
        this.data.sendToast(err?.error?.error || "A művelet sikertelen.", "error");
      },
    });
  }

  belepes() { this.idoszakMuvelet("belepes"); }
  kilepes() { this.idoszakMuvelet("kilepes"); }

  torolIdoszak(id) {
    this.data.showLoading("Időszak törlése...");
    this.http.delete("/api/etkezes/idoszak/" + id).subscribe({
      next: (res: any) => {
        this.data.hideLoading();
        this.data.sendToast("Időszak törölve.", "success");
        this.bezarIdoszak();
        this.getMunkatarsakNew();
      },
      error: () => {
        this.data.hideLoading();
        this.data.sendToast("A törlés sikertelen.", "error");
      },
    });
  }

  /** A menü megjelenítendő neve. Azonos nevű menüknél a beszállító különbözteti meg. */
  private menuNeve(user: any, menuId: any): string {
    const menu = (user?.menuk || []).find((mm: any) => String(mm?.id) === String(menuId));
    if (!menu) return 'Menü nélkül';
    const hely = (user?.beszallitok || []).find((b: any) => String(b?.id) === String(menu.etkezes_helye));
    const nev = String(menu.nev || 'Menü').trim();
    return hely?.nev ? `${nev} – ${hely.nev}` : nev;
  }

  /* ─────────── ÉTLAP a rendelési cellák mellett ───────────
     A szülő eddig úgy választott „A” és „B” között, hogy nem látta, mi van mögöttük. Az
     étlapot a beszállító Exceljéből az admin tölti fel (Admin → Étkezés → Étlap); itt a
     megjelenített hónapé töltődik be, és a nap sorában / cellájának címében látszik. Ha az
     intézmény nem tölt fel étlapot, semmi nem változik a képernyőn. */
  etlapNap: Record<string, EtlapSor[]> = {};

  private betoltEtlap(y, m) {
    if (!this.sajatIntezmeny?.intezmenyId) return;
    const ev = Number(y); const ho = Number(m);
    const tol = `${ev}-${String(ho).padStart(2, '0')}-01`;
    const ig = `${ev}-${String(ho).padStart(2, '0')}-${String(new Date(ev, ho, 0).getDate()).padStart(2, '0')}`;
    this.http.get<any>('/api/etkezes-etlap/lista/' + this.sajatIntezmeny.intezmenyId, { params: { tol, ig } })
      .subscribe({
        next: (r) => { this.etlapNap = etlapNaponta(r?.sorok || []); this.ref.detectChanges(); },
        //  Az étlap kiegészítő adat: ha nem jön meg, a rendelés ettől még működik.
        error: () => { this.etlapNap = {}; },
      });
  }

  private napDatum(idx: number): string {
    return `${this.selectedYear}-${String(this.selectedMonth).padStart(2, '0')}-${String(idx + 1).padStart(2, '0')}`;
  }

  /** A nap összes étlap-sora: „A: tojásos nokedli · B: rántott csirke”. */
  napEtlapOsszes(idx: number, elvalaszto = ' · '): string {
    return (this.etlapNap[this.napDatum(idx)] || []).map(s => `${s.menu_nev}: ${s.leiras}`).join(elvalaszto);
  }

  /** Egy rendelhető menü étele az adott napon (üres, ha nincs rá étlap). */
  napMenuEtele(user, idx: number, menuId): string {
    const sorok = this.etlapNap[this.napDatum(idx)];
    if (!sorok?.length || !menuId) return '';
    const menu = osszesMenu(user).find((x: any) => x.id == menuId);
    return menuEtele(sorok, menuId, menu?.nev, menu?.etkezes_helye || user?.selectedHely);
  }

  /*  A LISTA-NÉZET SORÁBA: kért napon a kért menü étele; ahol választani kell (több menü),
   *  az összes menü étele, hogy a döntéshez lássa; egy menünél annak étele. Ha a fájl
   *  jelei egyik menühöz sem illeszkednek, a nap teljes étlapja – inkább több, mint semmi. */
  napEtelSzoveg(user, idx: number): string {
    const sorok = this.etlapNap[this.napDatum(idx)];
    if (!sorok?.length) return '';
    const d = user?.adatok?.[idx];
    let etel = '';
    if (d?.value == 1) etel = this.napMenuEtele(user, idx, d.menu || user.selectedMenu);
    else if (user?.menuk?.length === 1) etel = this.napMenuEtele(user, idx, user.menuk[0].id);
    return etel || this.napEtlapOsszes(idx);
  }

  /** Címke-utótag a menü-jelölőkhöz / választókhoz: „ – Tojásos nokedli”. */
  napMenuEtelUtotag(user, idx: number, menuId): string {
    const etel = this.napMenuEtele(user, idx, menuId);
    return etel ? ' – ' + etel : '';
  }

  getData(y, m) {
    this.betoltEtlap(y, m);
    for (let i = 0; i < 32; i++) { this.osszegzes[i] = 0 }
    // Menünkénti napi bontás újraszámolása.
    const menuTerkep = new Map<string, { kulcs: string; nev: string; napok: number[] }>();
    this.getHolidays(true).pipe(
      switchMap((response1: any[]) => {
        // Pre-process holidays into a Set for faster lookup.
        // A -2 (áthelyezett munkanap) NEM szünet – az tanítási nap.
        const holidaysSet = new Set((response1 || [])
          .filter((h: any) => Number(h.type) !== -2)
          .map(holiday => new Date(holiday.date).toDateString()));


        // Process data here
        const days = new Date(y, m, 0).getDate();
        (this.ports || []).forEach((item: any) => {
          item.nyilv = new Array(days).fill(0);
          item.osszora = 0;

          for (let i = 0; i < days; i++) {
            // A napi rekord hiányozhat (rövidebb adatsor): ilyenkor a nap üres,
            // nem pedig az egész képernyő betöltési hibája.
            const nap = item.adatok?.[i];
            if (nap && nap.value == 1) {
              this.osszegzes[i]++;
              // A megrendelt nap menüje. Ha nincs rajta menü, külön sorban látszik,
              // hogy ne tűnjön el a darabszám a bontásból.
              const menuId = String(nap.menu || '');
              const kulcs = menuId || '__nincs__';
              if (!menuTerkep.has(kulcs)) {
                menuTerkep.set(kulcs, {
                  kulcs,
                  nev: menuId ? this.menuNeve(item, menuId) : 'Menü nélkül',
                  napok: new Array(32).fill(0),
                });
              }
              menuTerkep.get(kulcs).napok[i]++;
            }
            const currentDate = new Date(y, m - 1, i + 1);
            let isHoliday = holidaysSet.has(currentDate.toDateString());
            let isWeekend = currentDate.getDay() === 0 || currentDate.getDay() === 6;

            if (isWeekend) {
              item.nyilv[i] = 1;
            } else if (isHoliday) {
              item.nyilv[i] = 2;
            } else {
              item.nyilv[i] = 10;
              //console.log(item.adatok)
              item.osszora = this.hanyados * (item.adatok || []).filter(d => d?.value == 1).length;

            }
          }
        });

        // A bontás a menü nevével rendezve, a "Menü nélkül" a végére.
        this.menuOsszegzes = [...menuTerkep.values()].sort((a2, b2) =>
          (a2.kulcs === '__nincs__' ? 1 : 0) - (b2.kulcs === '__nincs__' ? 1 : 0)
          || a2.nev.localeCompare(b2.nev, 'hu'));

        // Assuming this.populateDaysInMonth() processes the final data and updates the UI accordingly
        this.populateDaysInMonth(response1); // Now called with the correct context

        return of({}); // Complete the observable chain

      }),
      catchError(error => {
        console.error('Error fetching data:', error);
        this.data.hideLoading();
        alert('Nem sikerült betölteni az adatokat! Kérjük próbálja újra.');
        return of({}); // Handle errors appropriately
      })
    ).subscribe();
  }

  logout() {
    this.auth.logout()
  }

  initModal(a, b = 0) {

  }


  startSelection(i: number, j: number) {
    this.isSelecting = true;
    this.addSelection(i, j);
  }

  dragSelection(i: number, j: number) {
    if (this.isSelecting) {
      this.addSelection(i, j);
    }
  }

  endSelection() {
    this.isSelecting = false;
  }

  isSelected(i: number, j: number): boolean {
    return this.selectedCells.has(`${i}-${j}`);
  }

  private addSelection(i: number, j: number) {
    this.selectedCells.add(`${i}-${j}`);
  }

  mouseUpEvent() {
    this.isSelecting = false;
    console.log(Array.from(this.selectedCells)); // Do something with the array of selected cells
  }

  replaceAccentedChars(str) {
    return str
    var accents = "ő_∑_ű_";
    var accentsOut = 'o"E u"';
    str = str.split('');
    var strLen = str.length;
    var i, x;
    for (i = 0; i < strLen; i++) {
      x = accents.indexOf(str[i]);
      if (x !== -1) {
        str[i] = accentsOut[x] + accentsOut[x + 1];
      }
    }
    return str.join('');
  }

  /*  AZ ÉTKEZÉSI LISTA NYOMTATÁSA a kiszolgáló riport-motorjával (backend/pdf-riport.js) –
   *  a munkaidő-elszámolás arculatával. A táblázatot az adatból építjük (nem a képernyőről):
   *  a cellákban gombok és legördülők állnak, a kiválasztott beszállító/menü a legördülő
   *  értéke, amit a DOM szövege nem ad vissza. A napi állapot jel + halvány szín, a jelek
   *  magyarázata a lap alján. Hiba esetén a régi, böngészős PDF készül. */
  async printData() {
    const fajlnev = this.selectedYear + "-" + this.selectedMonth + "_" + this.sajatIntezmeny?.intezmenyName + ".pdf";
    const napDb = this.daysInMonth?.length || 0;
    if (!napDb || !this.lathatoPortok.length) { this.printDataRegi(); return; }
    const honap = honapCimke(this.selectedYear, this.selectedMonth);
    const osztalyNev = this.valasztottOsztaly
      ? ((this.osztaly || []).find((o: any) => o.id == this.valasztottOsztaly)?.osztaly || '') : 'összes tanuló';
    try {
      await this.data.riportPdf({
        intezmeny: this.sajatIntezmeny?.intezmenyId,
        cim: 'Étkezés-nyilvántartás',
        cimKieg: 'havi lista',
        alcim: `${honap}${osztalyNev ? ` · ${osztalyNev}` : ''}`,
        adatsav: [['Időszak', honap], ['Osztály', osztalyNev || '—'],
          ['Étkezők', String(this.lathatoPortok.length)]],
        lapmeret: 'A4', tajolas: 'fekvo', betumeret: 7.5,
        tablak: [this.etkezesRiportTabla()],
        lablec: {
          kelt: true, keszitette: this.sajatnev,
          megjegyzes: 'Jelek: ✓ = kért nap, ✓✓ = számlázott, … = számlázás folyamatban, × = nem kért, '
            + '– = étkezési időszakon kívül, P = iskolai program miatt lemondva (nem kérhető újra), '
            + 'szürke = nincs étkezés (hétvége, szünet).'
            + (this.napiMenu ? ' Napi menüválasztásnál a kért nap cellájában a menü jele áll.' : ''),
        },
        fajlnev,
      }, fajlnev, 'letolt');
    } catch (e: any) {
      console.warn('Étkezési lista PDF (kiszolgáló) hiba, böngészős tartalék:', e);
      this.data.sendToast(`A PDF a régi formában készült (${e?.message || e}).`, 'warning');
      this.printDataRegi();
    }
  }

  /** A havi étkezési lista táblája a riport-motornak (a képernyő oszlopai, „Műveletek” nélkül). */
  private etkezesRiportTabla(): RiportTabla {
    const napDb = this.daysInMonth.length;
    const SZURKE = '#9e9e9e';
    const oszlopok: RiportOszlop[] = [
      { nev: 'Személy', szelesseg: '36mm' },
      ...this.daysInMonth.map((_, i) => ({ nev: ('0' + (i + 1)).slice(-2), igazitas: 'kozep' as const })),
      { nev: 'Beszállító / menü', szelesseg: '46mm' },
      { nev: '∑ (Ft)', igazitas: 'jobb', szelesseg: '17mm' },
    ];
    const napCella = (user: any, idx: number): RiportCella => {
      const d = user?.adatok?.[idx];
      if (!d) return '';
      if (this.napiCella(user, idx)) {
        return d.value == 1 ? { t: this.napiMenuSzam(user, idx), hatter: '#2dd36f', fej: true } : { t: '×', halvany: true };
      }
      if (d.value == 1 && d.tranzakcio == 1) return { t: '✓✓', hatter: '#2dd36f', fej: true };
      if (d.value == 1 && d.tranzakcio == 2) return { t: '…', hatter: '#ffc409' };
      if (d.value == 1) return { t: '✓', hatter: '#2dd36f' };
      if (d.value == 0) return { t: '×', halvany: true };
      if (d.value == -1) return { t: '', hatter: SZURKE };
      if (d.value == -2) return { t: '–', hatter: SZURKE, halvany: true };
      if (d.value == -3) return { t: 'P', hatter: '#ffc409' };
      return '';
    };
    const beszallito = (user: any): string => {
      const sorok = [this.helyNeve(user, user.selectedHely)];
      const menuk = user.menuk || [];
      if (!menuk.length) sorok.push('Nincs menü');
      else if (menuk.length == 1) sorok.push(`${menuk[0].nev} (${menuk[0].ar} Ft)`);
      else if (this.napiMenu) menuk.forEach((m: any) => sorok.push(`${this.menuCimke(user, m.id)} = ${m.nev} (${m.ar} Ft)`));
      else {
        const m = menuk.find((x: any) => x.id == user.selectedMenu);
        if (m) sorok.push(`${m.nev} (${m.ar} Ft)`);
      }
      return sorok.filter(Boolean).join('\n');
    };
    const nev = (user: any) => `${user.viselt_vez || ''} ${user.viselt_ker || ''}`.trim();

    const sorok: RiportSor[] = this.lathatoPortok.map((user: any) => user.aktiv
      ? [{ t: nev(user), fej: true }, ...this.daysInMonth.map((_, idx) => napCella(user, idx)),
        beszallito(user), String(user.osszeg || 0)]
      : [{ t: nev(user), fej: true },
        { t: 'Nincs étkezési bejelentkezés', cs: napDb + 2, hatter: SZURKE, halvany: true, igazitas: 'kozep' }]);

    //  Napi összesítés: összesen és menünként (a beszállítónak menünként kell leadni).
    const szunnap = (idx: number) => this.daysInMonth[idx]?.isWeekend || this.daysInMonth[idx]?.isHoliday;
    const napiSor = (cimke: string, ertek: (idx: number) => any, kiemelt = false): RiportSor => ({
      cellak: [
        { t: cimke, fej: true },
        ...this.daysInMonth.map((_, idx) => (szunnap(idx) ? { t: '', hatter: SZURKE } : String(ertek(idx) ?? ''))),
        { t: '', cs: 2 },
      ],
      ...(kiemelt ? { tipus: 'kiemelt' as const } : {}),
    });
    sorok.push({ csoport: 'Napi összesítés' });
    sorok.push(napiSor('Napi összes (db)', (idx) => this.osszegzes[idx] ?? 0, true));
    for (const mo of this.menuOsszegzes || []) sorok.push(napiSor(`  ${mo.nev}`, (idx) => mo.napok[idx] || ''));
    return { cim: 'Havi étkezési lista', osszegzes: `${this.lathatoPortok.length} étkező`, oszlopok, sorok };
  }

  printDataRegi() {
    const table = document.getElementById('printable');
    // Nyomtatáskor a napi menüválasztók helyett a menü SORSZÁMA kerül a cellába:
    // a legördülő szövegét a PDF-generátor amúgy is olvashatatlanul szedné ki.
    table?.classList.add('nyomtatas');

    let pdf = new jsPDF('l', 'mm', 'a4');


    //pdf.setFont('Bitter-Regular', 'normal')
    pdf.addFileToVFS("Bitter-Regular-normal.ttf", font);
    pdf.addFont("Bitter-Regular-normal.ttf", "Bitter-Regular", "normal");
    pdf.addFileToVFS("Bitter-Bold-normal.ttf", fontB);
    pdf.addFont("Bitter-Bold-normal.ttf", "Bitter-Bold", "bold");
    pdf.setFont("Bitter-Regular");

    pdf.text("Étkezés-nyilvántartás " + this.selectedYear + "-" + this.selectedMonth, 105, 10);


    function getBackgroundColor(cell) {
      return window.getComputedStyle(cell, null).getPropertyValue('background-color');
    }

    let nem = "data:image/png;base64,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"
    let igen = "data:image/png;base64,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"

    //console.log(pdf.getFontList());
    autoTable(pdf,
      {
        theme: 'grid',
        html: '#printable',
        styles: { overflow: 'linebreak', fontSize: 6, font: 'Bitter-Regular', halign: 'center', valign: 'middle' },
        headStyles: { fillColor: [56, 128, 255], fontStyle: 'bold', font: 'Bitter-Bold' }, alternateRowStyles: { fillColor: [237, 238, 242] }, tableLineColor: [0, 0, 0], /*alternateRowStyles: {fillColor : [231, 215, 252]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,*/
        didDrawCell: (data) => {
          //console.log(data)
          const cell = data.cell;
          //console.log(cell.raw)
          if (cell.text[0] == '  ') {
            pdf.setFillColor("#d3d3d3"); // Set the background color
            pdf.rect(cell.x, cell.y, cell.width, cell.height, 'F');
          } else if (cell.text[0] == '') {
            if (cell.raw["outerHTML"].includes("close")) {
              //cell.raw["innerHTML"] = "i"
              //pdf.setFillColor("#FFF5EE");
              pdf.rect(cell.x, cell.y, cell.width, cell.height, 'F');
              pdf.setFontSize(12);
              pdf.text("X", cell.x + 1.5, cell.y + 4);
              //pdf.addImage(nem, 'PNG', cell.x + cell.width/2 - 1.5, cell.y + 2 + 7, 3, 3);
            } else if (cell.raw["outerHTML"].includes("checkmark")) {
              //cell.raw["innerHTML"] = "n"
              //pdf.setFillColor("#e6ffe6");
              pdf.rect(cell.x, cell.y, cell.width, cell.height, 'F');
              pdf.setFontSize(12);
              pdf.text("I", cell.x + 1.5, cell.y + 4);
              //pdf.addImage(igen, 'PNG', cell.x + cell.width/2 - 1.5, cell.y + 2 + 7, 3, 3);
            }
            //pdf.text("!",cell.x+2, celltextPos.y + (cell.height - imageHeight) / 2);
          } else {
            if (cell.raw["outerHTML"].includes("Műveletek")) {
              //pdf.setFillColor("#d3d3d3"); // Set the background color
              //pdf.rect(cell.x, cell.y, cell.width, cell.height, 'F');
            } else if (cell.raw["outerHTML"].includes("Összes")) {
              pdf.setFillColor("#d3d3d3"); // Set the background color
              pdf.rect(cell.x, cell.y, cell.width, cell.height, 'F');
              //cell.text[0] = "-"
            }
            //pdf.text("!",cell.x+2, cell.y+2);
          }
          /*if (data.section === 'body' && data.column.index === 0) {
            var base64Img = 'data:image/jpeg;base64,iVBORw0KGgoAAAANS...'
            pdf.addImage(base64Img, 'JPEG', data.cell.x + 2, data.cell.y + 2, 10, 10)
          }*/
        },
        didParseCell: (data) => {

        },
        didDrawPage: (data) => {
          var pageSize = pdf.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          var pageWidth = pageSize.width
            ? pageSize.width
            : pageSize.getWidth();
          pdf.setFontSize(8);
          var img = new Image(); //this mount a variable to img
          img.src = '/assets/icon/favicon.png' //asign the src to the img variable
          pdf.addImage(img, 'png', data.settings.margin.left, pageHeight - 15, 10, 10)// use the method doc.autoTable.previous.finalY + lineHeight * 1.5 + offsetY to be able to position the image of the signature below the table at a safe distance from it

          pdf.text("Készült a Sulinform ERP rendszerében " + moment().format("YYYY-MM-DD HH:mm") + ". Generálta: " + this.sajatnev, data.settings.margin.left + 10, pageHeight - 10);
          pdf.text(data.pageNumber + "", pageWidth - 20, pageHeight - 10);
        },
      })

    //table.fromHTML()
    table?.classList.remove('nyomtatas');
    pdf.save(this.selectedYear + "-" + this.selectedMonth + "_" + this.sajatIntezmeny.intezmenyName + ".pdf")

  }

  diffDateHours(start, end) {
    try {
      return (
        Math.abs(new Date(end).getTime() - new Date(start).getTime()) / 36e5
      ).toFixed(2);
    } catch (error) {
      return '-';
    }
  }

  createMessageHandler(iframe: HTMLIFrameElement) {
    return function handleMessage(event: MessageEvent) {
      if (event.data.allApiCallsCompleted) {
        setTimeout(() => {
          iframe.contentWindow?.print();
          // Remove the event listener after printing

        }, 1000);
        window.removeEventListener('message', handleMessage, false);
      }
    };
  }

  printUrl(url: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url + "&sajatintezmeny=" + JSON.stringify(this.sajatIntezmeny);

    iframe.onload = () => {
      try {
        // Wait for the content to load fully before printing
        const messageHandler = this.createMessageHandler(iframe);

        // Add the event listener using the handler function
        window.addEventListener('message', messageHandler, false);

      } catch (error) {
        console.error('Error printing iframe content:', error);
      } finally {
        // Remove the iframe after a delay to ensure print dialog appears
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 5000);
      }
    };

    document.body.appendChild(iframe);
  }
}
